import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../../shared';

import {
    LogService,
    LogPopupService,
    LogComponent,
    LogDetailComponent,
    LogDialogComponent,
    LogPopupComponent,
    LogDeletePopupComponent,
    LogDeleteDialogComponent,
    logRoute,
    logPopupRoute,
    LogResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...logRoute,
    ...logPopupRoute,
];

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        LogComponent,
        LogDetailComponent,
        LogDialogComponent,
        LogDeleteDialogComponent,
        LogPopupComponent,
        LogDeletePopupComponent,
    ],
    entryComponents: [
        LogComponent,
        LogDialogComponent,
        LogPopupComponent,
        LogDeleteDialogComponent,
        LogDeletePopupComponent,
    ],
    providers: [
        LogService,
        LogPopupService,
        LogResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceLogModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/log/log.module.ts